import { actionTypes } from "./Actions";

const initialState = {
  accessToken: null,
  refreshToken: null,
  allUserDetails: [],
  userDetails: null,
  allEvents: [],
  eventDetails: null,
  formData: null,
  allUsersAndOrganiserDetails: [],
  homeImages: [],
  homepageReviews: [],
  environmentSelected: 'Testing',
  organisersAverageRating: [],
  MBTFeedbacks: [],
  allEventsFeedback: [],
  eventMetricsData: {},
  usersMetricsData: {},
  organisersMetricsData: {},
  bookingMetricsData: {},
  loginUserDetails: {},
  totalTravellersCount: 0,
  totalOrganiserCount: 0,
  totalTravellersOrganser: 0,
  totalEventsCount: 0,
};

export const reducerFunction = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.setAccessToken: {
      return { ...state, accessToken: action.payload };
    }
    case actionTypes.setRefreshToken: {
      return { ...state, refreshToken: action.payload };
    }
    case actionTypes.setAllUserDetails: {
      return { ...state, allUserDetails: action.payload };
    }
    case actionTypes.setUserDetails: {
      return { ...state, userDetails: action.payload };
    }
    case actionTypes.setAllEvents: {
      return { ...state, allEvents: action.payload };
    }

    case actionTypes.setEventDetails: {
      return { ...state, eventDetails: action.payload };
    }

    case actionTypes.setFormData: {
      return { ...state, formData: action.payload };
    }
    case actionTypes.setHomePageReviews: {
      return { ...state, homepageReviews: action.payload };
    }
    case actionTypes.setEnvironmentSelected: {
      return { ...state, environmentSelected: action.payload };
    }
    case actionTypes.setOrganisersAverageRating: {
      return { ...state, organisersAverageRating: action.payload };
    }
    case actionTypes.setMBTFeedbacks: {
      return { ...state, MBTFeedbacks: action.payload };
    }
    case actionTypes.setAllEventsFeedback: {
      return { ...state, allEventsFeedback: action.payload };
    }
    case actionTypes.setEventMetricsData: {
      return { ...state, eventMetricsData: action.payload };
    }
    case actionTypes.setUsersMetricsData: {
      return { ...state, usersMetricsData: action.payload };
    }
    case actionTypes.setOrganisersMetricsData: {
      return { ...state, organisersMetricsData: action.payload };
    }
    case actionTypes.setBookingMetricsData: {
      return { ...state, bookingMetricsData: action.payload };
    }
    case actionTypes.setLoginUserDetails: {
      return { ...state, loginUserDetails: action.payload };
    }
    case actionTypes.setTotalTravellersCount: {
      return { ...state, totalTravellersCount: action.payload };
    }
    case actionTypes.setTotalOrganisersCount: {
      return { ...state, totalOrganiserCount: action.payload };
    }
    case actionTypes.setTotalTravellersOrganisersCount: {
      return { ...state, totalTravellersOrganser: action.payload };
    }
    case actionTypes.setTotalEventsCount: {
      return { ...state, totalEventsCount: action.payload };
    }
    default:
      return state;
  }
};
